var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c("div", { staticClass: "cart-btn" }, [
        _c("a", { attrs: { href: "/cart" } }, [
          _c("div", { staticClass: "cart-icon" }, [
            _vm.cartLoaded && _vm.itemsCount > 0
              ? _c("span", { staticClass: "cart-count" }, [
                  _vm._v(_vm._s(_vm.itemsCount)),
                ])
              : _vm._e(),
            _vm._v(" "),
            _c(
              "svg",
              {
                attrs: {
                  xmlns: "http://www.w3.org/2000/svg",
                  viewBox: "0 0 24 24",
                },
              },
              [
                _c("path", { attrs: { fill: "none", d: "M0 0h24v24H0z" } }),
                _vm._v(" "),
                _c("path", {
                  attrs: {
                    d: "M6.5 2h11a1 1 0 01.8.4L21 6v15a1 1 0 01-1 1H4a1 1 0 01-1-1V6l2.7-3.6a1 1 0 01.8-.4zm12 4L17 4H7L5.5 6h13zM9 10H7v2a5 5 0 0010 0v-2h-2v2a3 3 0 01-6 0v-2z",
                  },
                }),
              ]
            ),
          ]),
        ]),
      ]),
      _vm._v(" "),
      _c("transition", { attrs: { name: "slide-fade" } }, [
        _c(
          "div",
          {
            directives: [
              {
                name: "show",
                rawName: "v-show",
                value: _vm.opened,
                expression: "opened",
              },
            ],
            staticClass: "cart__wrapper",
          },
          [
            _c("header", { staticClass: "cart__header" }, [
              _c("h4", { staticClass: "cart__heading" }, [
                _vm._v("Din kundvagn"),
              ]),
              _vm._v(" "),
              _c(
                "button",
                { staticClass: "cart__close", on: { click: _vm.toggle } },
                [
                  _c(
                    "svg",
                    {
                      attrs: {
                        xmlns: "http://www.w3.org/2000/svg",
                        viewBox: "0 0 24 24",
                        fill: "#31433c",
                      },
                    },
                    [
                      _c("path", {
                        attrs: { fill: "none", d: "M0 0h24v24H0z" },
                      }),
                      _vm._v(" "),
                      _c("path", {
                        attrs: {
                          d: "M12 10.586l4.95-4.95 1.414 1.414-4.95 4.95 4.95 4.95-1.414 1.414-4.95-4.95-4.95 4.95-1.414-1.414 4.95-4.95-4.95-4.95L7.05 5.636z",
                        },
                      }),
                    ]
                  ),
                ]
              ),
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "cart__content" }, [
              _c(
                "ul",
                _vm._l(_vm.cart, function (item) {
                  return _c(
                    "li",
                    { key: item.key, staticClass: "cart-item" },
                    [_c("cart-item", { attrs: { item: item } })],
                    1
                  )
                }),
                0
              ),
            ]),
            _vm._v(" "),
            _vm.cart.length
              ? _c("footer", { staticClass: "cart__footer" }, [
                  _c("div", { staticClass: "cart__total" }, [
                    _c("p", [_vm._v("TOTAL: " + _vm._s(_vm.total.toFixed(2)))]),
                    _vm._v(" "),
                    _c("p", [_vm._v("MOMS: " + _vm._s(_vm.taxes))]),
                  ]),
                  _vm._v(" "),
                  _c(
                    "a",
                    { staticClass: "cart__checkout", attrs: { href: "/cart" } },
                    [_vm._v("Till varukorg")]
                  ),
                ])
              : _vm._e(),
          ]
        ),
      ]),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }


// WEBPACK FOOTER //
// ./scripts/vue/Cart.vue